import { parseUTCDate } from 'utils/dateHelpers';

function removePreviousSchedules({ schedules, isTraveller = false }) {
  if (!schedules || schedules.length === 0) {
    return [];
  }

  const now = new Date();

  const filteredSchedules = schedules.filter((schedule) => {
    if (!schedule.startAtUTC && !schedule.startTime) {
      return true;
    }

    // Backend returns startAtUTC/startTime without a 'Z' suffix despite being
    // UTC — new Date() would misparse them as local time, so parse explicitly.
    const startAtUTC = parseUTCDate(schedule.startAtUTC || schedule.startTime);

    // Keep an ongoing session visible to the advisor until its actual end.
    // The previous ten-minute cutoff hid a 30-minute booking mid-call.
    const comparisonTime = new Date(startAtUTC);
    if (isTraveller) {
      comparisonTime.setHours(comparisonTime.getHours() + 1);
    } else {
      const endAtUTC = schedule.endAtUTC || schedule.endTime;
      const sessionEnd = endAtUTC && parseUTCDate(endAtUTC);
      if (sessionEnd && !Number.isNaN(sessionEnd.getTime())) {
        comparisonTime.setTime(sessionEnd.getTime());
      } else {
        comparisonTime.setMinutes(comparisonTime.getMinutes() + 10);
      }
    }

    // Filtrar agendamentos que estão no futuro ou dentro do tempo permitido de atraso
    return now <= comparisonTime;
  });

  return filteredSchedules;
}

export default removePreviousSchedules;
